if(!customElements.get('product-display')){
    class ProductDisplay extends HTMLElement {
        constructor() {
            super();

        }

        // Listen For Theme Events of Type UpdateCart
        cartUpdateUnsubscriber = undefined;
        optionsUpdateUnsubscriber = undefined;
        connectedCallback() {
            this.Initialize()
            this.cartUpdateUnsubscriber = SubscribeToEvent(`UpdateCart`, (eventData) => this.FetchDisplayPDP());
            this.optionsUpdateUnsubscriber = SubscribeToEvent(this.dataset.optionEventId, (eventData) => this.UpdateOptionEvent(eventData)
            );
        }
        Initialize() {
            this.GetVariantData()
            this.SetInitialOptions();
            this.ReloadOnSoldOut = true
        }

        disconnectedCallback() {
            this?.cartUpdateUnsubscriber?.();
            this?.optionsUpdateUnsubscriber?.();
        }
        
        FetchDisplayPDP(fetchUrl = this.dataset.url) {
            try {
                fetch(fetchUrl)
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html').querySelector('product-display');
                    if (html) {
                        this.innerHTML = html.cloneNode(true).innerHTML
                        document.documentElement.scrollTop = 0
                    }
                })
                
            } catch(error) {
                console.error(error);
            }
        }


        // NEW Product Structure
        
        GetVariantData() {
            return JSON.parse(this.querySelector('[type="application/json"]').textContent)
        }

        
        SetInitialOptions() {
            const CurrentOptions = Array.from(this.querySelectorAll('.OptionInput:checked')).map((select) => {
                return ({
                    OptionValue: select?.value, 
                    OptionPosition: select.dataset.optionPosition
                })
            })
            this.CurrentOptions = CurrentOptions
        }

        UpdateOptionEvent(eventData) {
            const {data} = eventData


            const NewOptions = this.CurrentOptions.filter(Option => Option.OptionPosition != data.OptionPosition)
            NewOptions.push({
                OptionValue: data.OptionValue,
                OptionPosition: data.OptionPosition,
            })
            
            this.CurrentOptions = NewOptions

            this.GetMatchingVariant()
        }

        GetMatchingVariant() {
            const FoundVariant = this.GetVariantData().find(Variant =>
                this.CurrentOptions.every(Option => Variant.options.includes(Option.OptionValue))
            )
            if (FoundVariant && this.dataset.updateUrl != 'false') {
                this.updateURL(FoundVariant)
                theme?.Overlay?.DeActivateOverlay?.()
            }
        }
        updateURL(FoundVariant) {
            this.FetchDisplayPDP?.(`${this.dataset.baseUrl}?variant=${FoundVariant.id}`)
            window?.history?.replaceState?.({}, '', `${this.dataset.baseUrl}?variant=${FoundVariant.id}`);
            theme?.Overlay?.DeActivateOverlay?.()
            if(this.ReloadOnSoldOut) {
                window.location.reload()
            }
        }
    }
    customElements.define('product-display', ProductDisplay);
}